import { useEffect } from 'react';

import { useBreakTimerStore } from '@/store/break-timer';

export function BreakTimerBootstrap() {
  const breakEndsAt = useBreakTimerStore((s) => s.breakEndsAt);
  const clearBreak = useBreakTimerStore((s) => s.clearBreak);

  useEffect(() => {
    if (!breakEndsAt) {
      return;
    }

    const remaining = breakEndsAt - Date.now();

    if (remaining <= 0) {
      clearBreak();
      window.dispatchEvent(new CustomEvent('break-finished'));
      return;
    }

    const timer = window.setTimeout(() => {
      clearBreak();
      window.dispatchEvent(new CustomEvent('break-finished'));
    }, remaining);

    return () => clearTimeout(timer);
  }, [breakEndsAt, clearBreak]);

  return null;
}
